import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as cluster from '../../space-clusters'

export const RESOURCE = {
  payload: {
    description: 'Used to assess the clustered space survey data',
    dimension: cluster.RESOURCE.payload,
    name: 'Clustered Space Survey data',
    partialId: PartialId.Standard.create('cluster_survey'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
